import * as React from 'react';
import {
  Box,
  Card,
  CardContent,
  CircularProgress
} from '@mui/material';
import { CTextField, CButton } from '../../../../components/common/Modal';
import { AdminCredentialsSection } from './AdminCredentialsSection';
import { TestConnectionAlert } from './TestConnectionAlert';

export const OracleEPMConnectionStep = ({
  mode,
  hostname,
  username,
  password,
  isAdminCredential,
  testLoading,
  testResult,
  loading,
  skipLoading,
  isValid,
  onHostnameChange,
  onUsernameChange,
  onPasswordChange,
  onAdminCredentialChange,
  onTestConnection,
  onSaveAndNext,
  onSkip
}) => {
  return (
    <Card variant="outlined">
      <CardContent>
        <CTextField
          id="hostname" 
          label="Hostname"
          size="small"
          variant="outlined"
          value={hostname}
          onChange={onHostnameChange}
          sx={{ marginTop: '1rem' }}
          fullWidth
        />
        
        <AdminCredentialsSection
          isAdminCredential={isAdminCredential}
          username={username}
          password={password}
          showTestButton={true}
          testLoading={testLoading}
          canTest={!!(hostname && username && password)}
          onAdminCredentialChange={onAdminCredentialChange}
          onUsernameChange={onUsernameChange}
          onPasswordChange={onPasswordChange}
          onTestConnection={onTestConnection}
        />
        
        <TestConnectionAlert testResult={testResult} />
        
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
          {mode === 'Edit' && (
            <CButton
              variant="outlined"
              onClick={onSkip}
              disabled={skipLoading}
              startIcon={skipLoading ? <CircularProgress size={16} /> : null}
            >
              {skipLoading ? 'Loading...' : 'Skip'}
            </CButton>
          )}
          <CButton
            variant="contained"
            onClick={onSaveAndNext}
            disabled={!isValid || loading}
            startIcon={loading ? <CircularProgress size={16} /> : null}
            sx={{ ml: 'auto' }}
          >
            {loading ? 'Saving...' : mode === 'Edit' ? 'Update and Next' : 'Save and Next'}
          </CButton>
        </Box>
      </CardContent>
    </Card>
  );
};

